import { getRoot, types } from 'mobx-state-tree';
import { Place, IPlace } from './PlaceStore';
import { IRootStoreAny } from './rootUtilType';
export const Traceability = types.model({
  income: types.maybeNull(types.number),
  income_unit: types.maybeNull(types.string),
  harvest_destination_places: types.array(types.safeReference(types.late(() => Place), {
    get(identifier, parent) {
      const uiStore = getRoot<IRootStoreAny>(parent).uiStore;
      return uiStore.currentOrganization?.placeStore.places.get(identifier);
    },
    set(value: IPlace) {
      return value.name;
    }
  })),
  crop_quality: types.map(types.number)
});